import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";

const DateTextField = (props) => {
  const { value, onChange, ...rest } = props;
  const [dateString, timeString] = value.toISOString().split("T");
  const [stringValue, setStringValue] = useState(dateString);
  const [valid, setValid] = useState(true);

  const handleChange = (event) => {
    console.log(event.target.value);
    setValid(event.target.value !== "");
    setStringValue(event.target.value);
  };

  useEffect(() => {
    if (valid) {
      const newDateString = `${stringValue}T${timeString}`;
      console.log(newDateString);
      const newDate = new Date(newDateString);
      onChange(newDate);
    }
  }, [stringValue]);

  return (
    <TextField
      {...rest}
      error={!valid}
      onChange={handleChange}
      type="date"
      value={stringValue}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default DateTextField;
